import React, { Component } from 'react';
import './PlannableItem.module.scss';
import connect from 'react-redux/es/connect/connect';
import { Draggable } from 'react-beautiful-dnd';

//import components
import Subject from 'components/UI/Subject/Subject';

const mapStateToProps = (state, props) => {
    return {
        user_subjects: state.user_subject.entities,
        homework: state.homework.entities,
        colors: state.color.entities,
        user: state.authentication.user
    };
};

class PlannableItem extends Component {

    render() {
        const { task, user_subjects, homework, colors, style } = this.props;

        const hw = homework.byId[task.homework_id];

        let subject = null;

        if (hw) {
            subject = user_subjects.byId[hw.user_subject_id];
        }
        return (
            <Draggable draggableId={`task-${task.id}`} key={`task-${task.id}`} index={this.props.index}>
                {(provided) => (
                    <div styleName="plannable-item-background" style={style} {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}>
                        <div styleName="plannable-item-content">
                            <div styleName="subject">
                                {
                                    task.homework_id == null ?
                                        <Subject misc color='#f8e764' /> :
                                        <Subject abbreviation={subject && subject.subject_abbreviation} color={subject && colors && colors.byId[subject.color_id].color}/>
                                }
                            </div>
                            <div styleName="description">
                                <p>{task.name}</p>
                            </div>
                            {
                                (this.props.user && this.props.user.use_timer) ?
                                    <div styleName="time">
                                        <p>{task.time} min</p>
                                    </div>
                                    :
                                    null
                            }
                        
                        </div>
                    </div>
                )}
            </Draggable>
        );
    }
}

export default connect(mapStateToProps, null)(PlannableItem);